import React, { useCallback, useState, useEffect } from "react";
import "./ScrollBar.less"
const SCROLL_BAR_WIDTH = 12;

const VerticalScrollBar = (props) => {
  const [VerticalScrollProgress, setVerticalScrollProgress] = useState(0);
  const [VerticalScrollBarHeight, setVerticalScrollBarHeight] = useState(0);
  const [targetHeight, setTargetHeight] = useState(0);
  const [targetTop, setTargetTop] = useState(0);
  const [targetRight, setTargetRight] = useState(0);
  let touchY = 0;
  
  const target = props.target
  let targetScrollHeight = 0;
  let targetScrollTop = 0;
  
  useEffect(()=> {
    setTargetHeight(target.getBoundingClientRect().height);
    targetScrollHeight = target.scrollHeight;
    targetScrollTop = target.scrollTop;
    setTargetTop(target.getBoundingClientRect().top);
    setTargetRight(target.getBoundingClientRect().right);
    setVerticalScrollProgress(targetScrollTop / (targetScrollHeight - targetHeight));
    setVerticalScrollBarHeight(targetHeight * targetHeight / targetScrollHeight);
    target.addEventListener("scroll",handleVerticalScroll,{ passive: true });
    return () => {
      target.removeEventListener("scroll", handleVerticalScroll, { passive: true});
    }
  })

  const handleVerticalScroll = useCallback((e) => {
    const {scrollTop, scrollHeight, clientHeight} = e.currentTarget
    if(targetScrollTop === scrollTop) return;
    targetScrollTop = scrollTop;
    setVerticalScrollProgress(scrollTop / (scrollHeight - clientHeight));
  },[])

  const startDrug = useCallback((e) => {
    if(e.touches.length < 1) return;
    if(e.changedTouches.length < 1) return;
    touchY = e.changedTouches[0].pageY
  },[])
  const handleDrug = useCallback((e, targetEl) => {
    if(e.touches.length < 1) return;
    if(e.changedTouches.length < 1) return;
    const speed = -2;
    const range = touchY - e.changedTouches[0].pageY;
    targetEl.scrollBy({
      top: range * speed,
      left: 0,
    })
    touchY = e.changedTouches[0].pageY
  },[])
  
  return targetHeight === VerticalScrollBarHeight ? null : (
    <div
      className="scrollBarArea"
      style={{
        width: SCROLL_BAR_WIDTH,
        height: `${targetHeight}px`,
        left: targetRight - SCROLL_BAR_WIDTH,
        top: targetTop,
      }}
    >
      <div
        className="scrollBarItem"
        style={{
          width: SCROLL_BAR_WIDTH,
          height: `${VerticalScrollBarHeight}px`,
          marginTop: 
            (targetHeight - VerticalScrollBarHeight) * VerticalScrollProgress,
        }}
        onTouchStart={(e)=>{
          startDrug(e)
        }}
        onTouchMove={(e) => {
          handleDrug(e, target)
        }}
      />
    </div>
  );
}

const HorizontalScrollBar = (props) => {
  const [HorizontalScrollProgress, setHorizontalScrollProgress] = useState(0);
  const [HorizontalScrollBarWidth, setHorizontalScrollBarWidth] = useState(0);
  const [targetWidth, setTargetWidth] = useState(0);
  const [targetBottom, setTargetBottom] = useState(0);
  const [targetLeft, setTargetLeft] = useState(0);
  let touchX = 0;
  
  const target = props.target
  let targetScrollWidth = 0;
  let targetScrollLeft = 0;
  
  useEffect(()=> {
    setTargetWidth(target.getBoundingClientRect().width);
    targetScrollWidth = target.scrollWidth;
    targetScrollLeft = target.scrollLeft;
    setTargetBottom(target.getBoundingClientRect().bottom);
    setTargetLeft(target.getBoundingClientRect().left);
    setHorizontalScrollProgress(targetScrollLeft / (targetScrollWidth - targetWidth));
    setHorizontalScrollBarWidth(targetWidth * targetWidth / targetScrollWidth);
    target.addEventListener("scroll",handleHorizontalScroll,{ passive: true });
    return () => {
      target.removeEventListener("scroll", handleHorizontalScroll, {passive: true})
    }
  })

  const handleHorizontalScroll = useCallback((e) => {
    const {scrollLeft, scrollWidth, clientWidth} = e.currentTarget
    if(targetScrollLeft === scrollLeft) return
    targetScrollLeft = scrollLeft;
    setHorizontalScrollProgress(scrollLeft / (scrollWidth - clientWidth));
  },[])

  const startDrug = useCallback((e) => {
    if(e.touches.length < 1) return;
    if(e.changedTouches.length < 1) return;
    touchX = e.changedTouches[0].pageX
  },[])
  const handleDrug = useCallback((e, targetEl) => {
    if(e.touches.length < 1) return;
    if(e.changedTouches.length < 1) return;
    const speed = -2;
    const range = touchX - e.changedTouches[0].pageX;
    targetEl.scrollBy({
      left: range * speed,
      top: 0,
    })
    touchX = e.changedTouches[0].pageX
  },[])
  return targetWidth === HorizontalScrollBarWidth ? null : (
    <div
      className="scrollBarArea"
      style={{
        width: `${targetWidth}px`,
        height: SCROLL_BAR_WIDTH,
        left: targetLeft,
        top: targetBottom - SCROLL_BAR_WIDTH,
      }}
    >
      <div
        className="scrollBarItem"
        style={{
          width: `${HorizontalScrollBarWidth}px`,
          height: SCROLL_BAR_WIDTH,
          marginLeft: 
            (targetWidth - HorizontalScrollBarWidth) * HorizontalScrollProgress,
        }}
        onTouchStart={(e)=>{
          startDrug(e)
        }}
        onTouchMove={(e) => {
          handleDrug(e, target)
        }}
      />
    </div>
  );
}

const ScrollBar = (props) => {
  if(!props.target) return null;
  return (
    <>
      <VerticalScrollBar target={props.target} />
      <HorizontalScrollBar target={props.target} />
    </>
  );
}

export default ScrollBar